var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboardIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 77,
    height: 75,
    viewBox: "0 0 77 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M65.2027 47.5999L65.2776 27.384C65.2898 23.9104 63.4487 20.6884 60.448 18.9459L42.9939 8.78742C39.9949 7.04053 36.284 7.0296 33.2712 8.76076L15.7421 18.8181C12.7293 20.5493 10.8629 23.7515 10.849 27.2296L10.7741 47.4454C10.762 50.919 12.603 54.1411 15.6037 55.8835L33.0579 66.042C36.0569 67.7889 39.7677 67.7999 42.7806 66.0687L60.3096 56.0113C63.3269 54.2819 65.1888 51.0779 65.2027 47.5999Z",
    fill: "#6E9F4A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.5833 22.75V37.9167H23.75V22.75H35.5833ZM35.5833 42.75V51.25H23.75V42.75H35.5833ZM52.25 36.0833V51.25H40.4167V36.0833H52.25ZM52.25 31.25H40.4167V22.75H52.25V31.25Z",
    stroke: "white",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardIcon);
export default __webpack_public_path__ + "static/media/DashboardIcon.5de7a7724ff006c079c328d426676b56.svg";
export { ForwardRef as ReactComponent };